module.exports = __webpack_public_path__ + "icon-dojo-toolkit.1h1AYFZc.svg";